var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 8.66667L5.83331 6.5M3.45255 12.832C1.23296 10.4124 1.29527 6.6504 3.63949 4.30617C6.04772 1.89794 9.95224 1.89794 12.3605 4.30617C14.7047 6.6504 14.767 10.4124 12.5474 12.832",
    stroke: "#2B2F33",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimit);
export default __webpack_public_path__ + "static/media/limit.131788f2a16f0d6336a75fbfadc6b358.svg";
export { ForwardRef as ReactComponent };